export enum IncentiveStep {
	REGISTRATION = 'Registration',
	LOGIN = 'Login',
	OPT_IN = 'OptIn',
	CPI = 'CPI',
}
